import { z } from 'zod';
export const DEFAULT_PER_PAGE = 25;
export const MAX_PER_PAGE = 100;
export const uuidSchema = z.string().uuid();
/** Trimmed, non-empty string with an upper bound. */
export const nonEmptyString = (max, label = 'Value') => z
    .string({ required_error: `${label} is required` })
    .trim()
    .min(1, `${label} is required`)
    .max(max, `${label} must be at most ${max} characters`);
/** Optional free text: empty string is normalised to null. */
export const optionalText = (max = 10_000) => z
    .string()
    .trim()
    .max(max, `Must be at most ${max} characters`)
    .transform((value) => (value.length === 0 ? null : value))
    .nullable()
    .optional();
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(MAX_PER_PAGE).default(DEFAULT_PER_PAGE),
});
export const searchTermSchema = z.string().trim().min(1).max(200);
/** Accepts either an internal UUID or a human-readable key. */
export const idOrKeySchema = z.string().trim().min(1).max(64);
export const sortOrderSchema = z.enum(['asc', 'desc']).default('desc');
//# sourceMappingURL=common.js.map